import { PageHero } from "@widgets/page-hero";

import { ArticleContent } from "@features/article-content/ui";

import { DocumentsSection } from "@entities/document/ui/documents-section";

import { formatDateDot } from "@shared/utils/string";

import type { DocumentPageType } from "../model";

import s from "./document-page.module.scss";

export type DocumentPageProps = {
  document: DocumentPageType;
};

export const DocumentPage = (props: DocumentPageProps) => {
  const { document } = props;
  const displayDate = document?.updatedAt ?? document?.createdAt;
  const datePrefix = document?.updatedAt ? "Обновлено" : "Создано";
  return (
    <main className={s.root}>
      <PageHero
        variant="secondary"
        title={document?.title}
        updatedAt={
          displayDate
            ? `${datePrefix} ${formatDateDot(displayDate)}`
            : undefined
        }
        viewUpdatedAt={document?.viewUpdatedAt}
        textColor="brown"
        breadcrumbs={[]} //пока не добавили разводяющуюю
      />
      {document?.content && (
        <ArticleContent
          articleBlocks={document?.content}
          className={s.content}
        />
      )}
      {document?.otherDocuments && (
        <DocumentsSection data={document.otherDocuments} />
      )}
    </main>
  );
};

DocumentPage.displayName = "DocumentPage";
